import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../../Containers/Config/index.js';
import { CREATE_EVENT_RULE_WITH_USER_IDS, CREATE_EVENT_RULE_WITH_USER_IDS_SUCCESS, CREATE_EVENT_RULE_WITH_USER_IDS_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* createEventRuleWithUserIds({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/add-coins`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        'X-Api-Key': 'thriwe',
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: CREATE_EVENT_RULE_WITH_USER_IDS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_EVENT_RULE_WITH_USER_IDS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_EVENT_RULE_WITH_USER_IDS_ERROR, payload: error });
  }
}

export function* watchCreateEventRuleWithUserIds() {
  yield takeEvery(CREATE_EVENT_RULE_WITH_USER_IDS, createEventRuleWithUserIds);
}

function* createEventRuleWithUserIdsSaga() {
  yield all([fork(watchCreateEventRuleWithUserIds)]);
}

export default createEventRuleWithUserIdsSaga;
